import kyc1 from "./kyc1";
import kyc2 from "./kyc2";
import kyc4 from "./kyc4";

export const jsonFormSchema = [
    kyc1,
    kyc2,
    kyc4
];